import Layout from "../Layout";
import Card from "../Layout/Card";

export default function Terms() {
    return <Layout
        title="Terms of Service"
    ><Card>TBD</Card></Layout>
}
